import { useQuery } from 'react-query';
import type { OmniumStore } from '@fagmobler/omnium';
import { fetchStore } from '@/components/store/fetchers/fetchStore';

export type UseStoreProps = {
  initialData?: OmniumStore | null;
  enabled?: boolean;
};

export function useStore(
  storeId: string | null | undefined,
  { initialData, enabled }: UseStoreProps = {
    initialData: null,
    enabled: true,
  }
) {
  return {
    store: useQuery<OmniumStore | null>(
      'store',
      () => (storeId && fetchStore(storeId)) || null,
      { initialData, enabled }
    ),
  };
}
